import { render } from "./AboutPrinciples.vue?vue&type=template&id=2b240a4a"
import script from "./AboutPrinciples.vue?vue&type=script&lang=js"
export * from "./AboutPrinciples.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__